async function pingApi (axiosInstance, onError) {
  try {
    const response = await axiosInstance.get('/ping/')

    return !!(response && (response.status === 204 || response.statusCode === 204))
  } catch (err) {
    if (onError) onError(err)
    return false
  }
}

async function pingMapApi (axiosInstance, onError) {
  try {
    const response = await axiosInstance.get('/ping/')

    return !!(response && (response.status === 204 || response.statusCode === 204))
  } catch (err) {
    if (onError) onError(err)
    return false
  }
}

module.exports = {
  pingApi,
  pingMapApi
}
